export default __webpack_public_path__ + "static/media/wave-gradient.e4973659.png";